module.exports = __webpack_public_path__ + "img/nyomtatas-femgozolt-kartonra.c57bf08f.jpg";